import { NotificationsService } from "../notifications.service";
import { DashboardStore } from "../dashboard.store";
import { AddClientModalComponent } from "../main/accountant/modals/addClientModal.component";
import { ChatService } from "../chat.service";
import { PreferencesModalComponent } from "../main/common/modals/preferences-modal.component";
import { Intercom } from "@supy-io/ngx-intercom";
import {
  Component,
  OnInit,
  AfterViewInit,
  TemplateRef,
  ViewChild,
  ChangeDetectorRef,
  OnDestroy,
  Pipe,
  PipeTransform,
  forwardRef,
  DestroyRef,
  inject,
} from "@angular/core";
import { LocalStorageService } from "src/app/utils/localstorage.service";
import {
  ActivatedRoute,
  NavigationEnd,
  NavigationStart,
  Router,
  RouterLink,
  RouterLinkActive,
  RouterOutlet,
} from "@angular/router";
import { GeneralUtil } from "../../utils/general";
import { BsModalService } from "ngx-bootstrap/modal";
import { BsModalRef } from "ngx-bootstrap/modal";
import { DashboardService } from "../dashboard.service";
import { MyAccountModalComponent } from "../main/common/modals/my-account-modal.component";
import { MyAccountService } from "../main/common/modals/my-account-modal.service";
import { AccountantService } from "../main/accountant/accountant.service";
import { WorkspacesService } from "../main/accountant/workspaces.service";
import { ConversationsService } from "../conversations/conversations.service";
import { LoginService } from "../../login/login.service";
import { environment } from "../../../environments/environment";
import { GeneralNotificationSettingsModalComponent } from "../main/common/modals/general-notification-settings-modal.component";
import { AddExistingClientModalComponent } from "../main/accountant/modals/addExistingClientModal.component";
import { filter, Subject, take, takeUntil } from "rxjs";
import { RealTimeService } from "../main/common/notifications/real-time.service";
import { Job } from "../main/accountant/jobs-and-tasks/job.model";
import { StripeService } from "../main/accountant/stripe.service";
import { MyDevicesModalComponent } from "../main/common/modals/my-devices-modal.component";
import { NewTrackedItemModalComponent } from "../conversations/modals/new-tracked-item-modal.component";
import { TagAddComponent } from "../main/common/tags/tag-add/tag-add.component";
import { FilePreviewService } from "../main/common/file-preview.service";
import { JobPickerModalComponent } from "../main/accountant/modals/job-picker-modal.component";
import { GenericDrawerService } from "../drawer/global-drawer.service";
import {
  SharedDataService,
  SubscriptionErrorStatus,
  SubscriptionLabel,
  SubscriptionType,
  UserType,
} from "../shared-data.service";
import { AddClientWizardComponent } from "../../add-client-wizard/add-client-wizard.component";

import { JobsStore } from "../main/accountant/jobs-and-tasks/jobs.store";
import { EmailService } from "../email/email.service";
import { BatchActionMessageComponent } from "../main/accountant/modals/batch-action-message.component";
import { DrawerComponent } from "../drawer/drawer.component";
import { JobContentComponent } from "../main/accountant/jobs-and-tasks/job-content/job-content.component";
import { ClientTasksComponent } from "../main/accountant/client-tasks/client-tasks.component";
import { TagComponent } from "../main/common/tags/tag.component";
import { NotificationsComponent } from "../main/common/notifications/notifications.component";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { TooltipModule } from "ngx-bootstrap/tooltip";

import { NewFilePreviewComponent } from "../main/common/new-file-preview.component";
import { NgClass } from "@angular/common";
import { TimerComponent } from "../main/accountant/jobs-and-tasks/time-tracking/timer/timer.component";

import * as Sentry from "@sentry/angular";
import { NewVersionCheckerComponent } from "src/app/new-version-checker/new-version-checker.component";
import { AuthorizationService } from "src/app/services/authorization/authorization.service";
import { CurrentWorkspaceService } from "../main/accountant/current-workspace.service";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";

declare var jQuery: any;
declare var profitwell: any;

import posthog from "posthog-js";
import {
  PERMISSION_GENERAL_ACCESS_SETUP_AND_SETTINGS,
  ROLE_ADMIN,
  UserPermissions,
} from "src/app/services/authorization/authorization.models";

/**
 * Dashboard component. It's the main header after the user is logged in
 It's also responsible to retrieve the brand and user info whenever
 a login is successfull.
 */

@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.scss", "../main/accountant/tags.scss"],
  imports: [
    TimerComponent,
    NgClass,
    NewFilePreviewComponent,
    RouterLink,
    TooltipModule,
    RouterLinkActive,
    BsDropdownModule,
    NotificationsComponent,
    TagComponent,
    TagAddComponent,
    RouterOutlet,
    ClientTasksComponent,
    JobContentComponent,
    DrawerComponent,
    NewVersionCheckerComponent,
    forwardRef(() => ClientTagSearchPipe),
  ],
})
export class DashboardComponent implements OnInit, AfterViewInit, OnDestroy {
  readonly PERMISSION_GENERAL_ACCESS_SETUP_AND_SETTINGS =
    PERMISSION_GENERAL_ACCESS_SETUP_AND_SETTINGS;
  readonly ROLE_ADMIN = ROLE_ADMIN;

  userPermissions: UserPermissions = {
    role: "",
    permissions: [],
  };

  @ViewChild("trialEnding", { static: true }) public trialEnding;
  @ViewChild("welcomeVideo", { static: true }) public welcomeVideo;
  @ViewChild("tagList") tagList: TagAddComponent;

  public conversationsOpen = false;

  loadings = {
    client_list: false,
  };

  private destroyRef = inject(DestroyRef);

  private destroy$ = new Subject<void>();
  open_tracked_items_count = null;
  clientFilter = "ACTIVE";
  public bsModalRef: BsModalRef;
  public user: any;
  data: any = { user_type: null };
  public generalUtil = new GeneralUtil();
  public company: any;
  menuOpen = false;
  notificationsOpen = false;
  notificationsCounter: any;
  hasUnreadNotifications = false;
  unreadNotificationsCounter = 0;
  openHelp = false;
  public clientListOpen =
    this.localStorage.get("client_list_open") != null
      ? this.localStorage.get("client_list_open")
      : true;
  public show_loading = false;
  public menu_collapsed = false;
  public modalRef: BsModalRef;
  public app_discovery = false;
  public one_signal = window["OneSignal"] || [];
  public navCollapsed: any;
  public windowWidth: any;
  isRouteOnWorkspaces = true;

  selectedTrackedItem = null;

  showJobModal = false;
  job = new Job();

  isPastPeriodEnd = false;
  isEligibleForGracePeriod = false;

  selectedFilterTags = [];

  isFilePreviewOpened = false;
  andOrFilter = "or";

  batch_client_tasks = false;
  selectedConversationIds: number[] = [];
  timeTrackingStatus;

  SubscriptionType = SubscriptionType;
  UserType = UserType;
  SubscriptionLabel = SubscriptionLabel;
  SubscriptionErrorStatus = SubscriptionErrorStatus;

  unreadThreadsCount = null;

  isEmailAvailable = false;
  isHuddleAvailable = false;

  constructor(
    public localStorage: LocalStorageService,
    public router: Router,
    public dashboardService: DashboardService,
    public modalService: BsModalService,
    public myAccountService: MyAccountService,
    public accountantService: AccountantService,
    public workspacesService: WorkspacesService,
    public conversationsService: ConversationsService,
    public loginService: LoginService,
    public intercom: Intercom,
    public chatService: ChatService,
    public cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
    public notificationsService: NotificationsService,
    public dashboardStore: DashboardStore,
    private realTimeService: RealTimeService,
    private stripeService: StripeService,
    private filePreviewService: FilePreviewService,
    private jobsStore: JobsStore,
    private emailService: EmailService,
    private authorizationSerice: AuthorizationService,
    public genericDrawerService: GenericDrawerService,
    public sharedDataService: SharedDataService,
    public BsModalRef: BsModalRef,
    private currentWorkspaceService: CurrentWorkspaceService,
  ) {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((sub) => {
        if (this.router.url.indexOf("/workspaces") > 0) {
          this.isRouteOnWorkspaces = true;
        } else {
          this.isRouteOnWorkspaces = false;
        }
      });

    posthog.identify(this.sharedDataService.user.email);
  }

  openNotifications(): void {
    this.notificationsOpen = !this.notificationsOpen;
    if (this.notificationsOpen) {
      this.notificationsCounter = setTimeout(() => {
        this.notificationsService.markAsRead().then((res) => {
          this.dashboardStore.markAllClientNotificationsAsRead();
        });
      }, 1500);
    } else {
      clearTimeout(this.notificationsCounter);
    }
  }

  closeNotifications(): void {
    this.notificationsOpen = false;
    clearTimeout(this.notificationsCounter);
    this.checkHasNotifications();
  }

  updateUserPermissions() {
    this.authorizationSerice
      .getUserPermissions()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (res) => {
          this.localStorage.set("userPermissions", res);
          this.userPermissions = res;
        },
        error: (err) => console.error(err),
      });
  }

  ngOnInit(): void {
    Sentry.setUser({ email: this.sharedDataService.user.email });

    this.updateUserPermissions();
    this.dashboardService.closeJobDrawer$.subscribe(() => {
      this.showJobModal = false;
      this.job = null;
    });

    if (this.sharedDataService.data["user_type"] == 1) {
      this.dashboardService.isEmailAvailable().then((res: any) => {
        this.isEmailAvailable = res;
      });
    }

    this.sharedDataService.$dataChanged.subscribe((sub) => {
      if (this.sharedDataService.data.user_type == 1) {
        if (
          this.sharedDataService.data.stripe_subscription_status == "canceled"
        ) {
          console.log("SUBSCRIPTION STATUS: GO TO SUBSCRIPTION");
          this.router.navigate(["../practice/subscription"]);
        } else if (
          this.sharedDataService.data.stripe_subscription_status == "past_due"
        ) {
          console.log("SUBSCRIPTION STATUS: GO TO PRACTICE INFO");
          this.router.navigate(["../practice/practice-info"]);
        }
      }
    });

    this.loadings["client_list"] = true;
    this.dashboardStore.clientsLoaded.subscribe((sub) => {
      this.loadings["client_list"] = false;

      this.notificationsService.getNotifications("0").then((notifications) => {
        for (let x = 0; x < this.dashboardStore.clients.length; x++) {
          let client = this.dashboardStore.clients[x];
          let has_notification = false;
          if (
            notifications.filter(
              (n) =>
                n.read == false &&
                n.notification.conversation ==
                  client["company_conversation"].id,
            ).length > 0
          ) {
            has_notification = true;
          }

          // #1665
          if (
            client["company_conversation"].uuid !=
            this.dashboardStore.activeConversationUUID
          ) {
            client["company_conversation"].has_notifications = has_notification;
          }
        }
      });
    });

    /* All this BS to fix the goddamn Active client menu on the left
    being marked as active when on another route
    */
    if (this.router.url.indexOf("/workspaces") > 0) {
      this.isRouteOnWorkspaces = true;
    } else {
      this.isRouteOnWorkspaces = false;
    }

    this.dashboardService.startTimeTracking
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        if (typeof data === "boolean") return this.onInitJobTimeTracking();
        this.timeTrackingStatus = data;
      });

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((sub) => {
        if (this.router.url.indexOf("/workspaces") > 0) {
          this.isRouteOnWorkspaces = true;
        } else {
          this.isRouteOnWorkspaces = false;
        }

        this.cdr.detectChanges();
      });
    // End of BS

    if (
      this.localStorage.get("company") == null ||
      this.localStorage.get("company") === undefined
    ) {
      this.router.navigate(["/registration/create"]);
    }

    this.dashboardService.show_loading.subscribe((sub) => {
      this.show_loading = sub;
    });

    this.accountantService.archiveCompany.subscribe((sub) => {
      for (let x = 0; x < this.dashboardStore.clients.length; x++) {
        if (this.dashboardStore.clients[x].id == sub.company_id) {
          this.dashboardStore.clients[x].archived = sub.archived;
          this.setClientFilter("ARCHIVED");
        }
      }
    });

    this.user = this.localStorage.get("user");
    this.onInitJobTimeTracking();
    this.company = this.localStorage.get("company");

    if (this.localStorage.get("data")["user_type"] == 2) {
      this.data = this.localStorage.get("data");
    }

    // this.dashboardService.show_loading.next(true);
    this.dashboardService.getOpenTrackedItemsCount.subscribe((sub) => {
      this.dashboardService.get_open_tracked_items_count().then(
        (res: any) => {
          this.open_tracked_items_count = res.open_tracked_items_count;
        },
        (err) => {
          this.open_tracked_items_count = null;
        },
      );
    });

    this.dashboardService.getOpenTrackedItemsCount.next(null);

    this.intercom.update({
      app_id: "wqv1cgow",
      name: `${this.localStorage.get("user")["first_name"]} ${
        this.localStorage.get("user")["last_name"]
      }`,
      email: this.localStorage.get("user")["email"],
      user_hash: this.localStorage.get("user")["user_hash"],
      userid: this.localStorage.get("user")["id"],
      created_at: new Date(this.localStorage.get("data")["created"]).getTime(),
      user_company: this.localStorage.get("company")["is_accounting"],
      company_name: this.localStorage.get("company")["name"],
      accounting_company_name:
        this.localStorage.get("company")["accounting_company"] != null
          ? this.localStorage.get("company")["accounting_company"]["name"]
          : null,
      user_type: this.localStorage.get("data")["user_type"],
      user_system: environment.production ? "prod" : "qa",
      is_owner:
        this.localStorage.get("user")["id"] ==
        this.localStorage.get("company")["owner"]
          ? true
          : false,
      first_name: this.localStorage.get("user")["first_name"],
      last_name: this.localStorage.get("user")["last_name"],
    });

    this.accountantService.getSubscriberInfo().then((res) => {
      profitwell("start", {
        user_email: this.localStorage.get("user")["email"],
        user_id: res.id,
      });
    });

    if (this.localStorage.get("data")["user_type"] == 1) {
      this.accountantService.get_subscription_status().then((res: any) => {
        const response = res;

        if (response.subscription !== null) {
          let data: any = this.localStorage.get("data");

          data.stripe_subscription_status =
            response.subscription.stripe_subscription_status;

          data.tier = response.subscription.tier;

          data.error_status = response.subscription.error_status;

          this.sharedDataService.data = data;

          this.data = data;

          this.isEligibleForGracePeriod =
            this.calculateIsEligibleForGracePeriod(
              this.data.current_period_end,
            );
          this.isPastPeriodEnd = this.calculateIsPastPeriodEnd(
            this.data.current_period_end,
          );
        } else {
          this.data = this.localStorage.get("data");
        }

        this.myAccountService.get_has_web_push().then((res: any) => {
          const response = res;
          let data: any = this.localStorage.get("data");
          data["has_web_push_enabled"] = response.has_web_push_enabled;
          this.localStorage.set("data", data);
          this.data = data;

          if (this.data["has_web_push_enabled"]) {
            this.one_signal.push(() => {
              this.one_signal.push(["registerForPushNotifications"]);

              this.one_signal.on("subscriptionChange", (isSubscribed) => {
                this.myAccountService.update_has_web_push(isSubscribed);
                this.one_signal.getUserId().then((userId) => {
                  if (userId)
                    this.myAccountService.set_push_keys({
                      userId: userId,
                      type: "WEB",
                    });
                });
              });
            });
          }
        });
      });
    }

    this.dashboardService.paymentDone.subscribe((sub) => {
      this.sharedDataService.data.stripe_subscription_status = "active";
    });

    this.menu_collapsed = this.localStorage.get("menu_collapsed");

    jQuery("body").on("click", ".help-groove", function () {
      jQuery("iframe.grv-widget-tag-bottom-left")
        .contents()
        .find(".grv-tab")
        .click();
    });

    jQuery("body").on("click", ".search-clients .x-circle", function () {
      jQuery(".search-clients .x-circle").hide();
      jQuery(".search-clients input").val("").trigger("keyup");
    });

    jQuery("body").on("keyup", ".search-clients #search-clients", function () {
      var value = jQuery(this).val().toLowerCase();

      if (value.length > 0) {
        jQuery(".search-clients .x-circle").show();
      } else {
        jQuery(".search-clients .x-circle").hide();
      }

      jQuery("body .clients-list-list .client-name").each(function () {
        if (
          jQuery(this).text().toLowerCase().search(value) > -1 ||
          jQuery(this).parent().hasClass("active")
        ) {
          jQuery(this).parent().parent().show();
        } else {
          jQuery(this).parent().parent().hide();
        }
      });
    });

    if (localStorage.getItem("clienthub.tour") == "completed") {
      this.app_discovery = this.localStorage.get("app_discovery");
    }

    if (window.innerWidth < 767) {
      this.navCollapsed = true;
      this.windowWidth = window.innerWidth;
    }

    if (this.data["user_type"] == 1) {
      this.router.navigate(["../practice/workspaces"]);
    } else if (this.data["user_type"] == 2) {
      this.router.navigate(["../client/workspaces"]);
    }

    this.checkHasNotifications();
    this.realTimeService.bellNotifications.subscribe(() =>
      this.checkHasNotifications(),
    );

    this.dashboardStore._selectJob.subscribe((job) => {
      this.showJobModal = true;
      this.job = job;
      this.cdr.detectChanges();
    });

    this.filePreviewService.openFile.subscribe((file) => {
      this.isFilePreviewOpened = true;
      this.cdr.detectChanges();
    });

    this.filePreviewService.closeFile.subscribe(() => {
      this.isFilePreviewOpened = false;
    });

    if (this.localStorage.get("fromSignUp") == true) {
      this.localStorage.set("fromSignUp", false);
      this.bsModalRef = this.modalService.show(this.welcomeVideo, {
        class: "modal-lg",
      });
    }

    this.sharedDataService.getSubscriptionType().then(
      (res) => {
        this.sharedDataService.subscriptionType = res.subscription_type;
      },
      (err) => {
        this.sharedDataService.subscriptionType = null;
      },
    );

    this.jobsStore.changeSelectedJob.subscribe((sub) => {
      if (sub != null) {
        this.job = sub;
        this.showJobModal = true;
      } else {
        this.showJobModal = false;
      }

      this.cdr.detectChanges();
    });

    this.emailService.getUnreadThreadsCount().subscribe((res: any) => {
      this.unreadThreadsCount = res.unread_threads_count;
    });
  }

  public openWelcomeVideo() {
    this.bsModalRef = this.modalService.show(this.welcomeVideo, {
      class: "modal-lg",
    });
  }

  ngOnDestroy(): void {
    // this.realTimeService.bellNotifications.unsubscribe();
    this.destroy$.next();
    this.destroy$.complete();
  }

  onInitJobTimeTracking() {
    this.dashboardService.timeTrackingStatus().then((res: any) => {
      this.timeTrackingStatus = res.time_tracking_status;
    });
  }

  checkHasNotifications() {
    this.notificationsService.hasNotifications().then((res) => {
      this.hasUnreadNotifications = res.unread;
      this.unreadNotificationsCounter = res.count;
    });
  }

  public skipAppDiscovery() {
    this.localStorage.set("app_discovery", false);
    this.app_discovery = false;
  }

  ngAfterViewInit() {
    jQuery(document).trigger("exec"); // Execute jQuery code on "cch-js.js" (tell jQuery that the DOM is ready)
    this.cdr.detectChanges();
  }

  public onResize(event) {
    if (event.target.innerWidth <= 1024) {
      jQuery(".ch-panel-links").addClass("panel-hidden");
    } else {
      jQuery(".ch-panel-links").removeClass("panel-hidden");
    }

    if (window.screen.width <= 767) {
      jQuery(".ch-panel").addClass("panel-hidden");
      jQuery(".ch-panel:eq(0)").removeClass("panel-hidden");
    } else {
      jQuery(".ch-panel-conversations").removeClass("panel-hidden");
    }
  }

  public toggleMenu() {
    if (this.localStorage.get("menu_collapsed") == false) {
      this.localStorage.set("menu_collapsed", true);
      this.menu_collapsed = true;
    } else {
      this.localStorage.set("menu_collapsed", false);
      this.menu_collapsed = false;
    }
  }

  public toggleClientList() {
    if (this.clientListOpen == false) {
      this.localStorage.set("client_list_open", true);
      this.clientListOpen = true;
    } else {
      this.localStorage.set("client_list_open", false);
      this.clientListOpen = false;
    }
  }

  public openMyAccountModal() {
    this.bsModalRef = this.modalService.show(MyAccountModalComponent, {
      class: "modal-lg",
    });
  }

  public openMyDevicesModal() {
    this.bsModalRef = this.modalService.show(MyDevicesModalComponent, {
      class: "modal-lg",
    });
  }

  public openGeneralNotificationSettingsModal() {
    this.bsModalRef = this.modalService.show(
      GeneralNotificationSettingsModalComponent /*, {class: 'modal-lg'}*/,
    );
  }

  public openPreferencesModal() {
    this.bsModalRef = this.modalService.show(PreferencesModalComponent);
  }

  public openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: "modal-sm" });
  }

  /**
   * Logout the current user by deleting the access_toekn from the localStorage.
   */
  public logout(): void {
    this.loginService.logout();
  }

  public showFloatingChat() {
    return this.router.url.indexOf("workspaces") == -1;
  }

  setClientFilter(filter) {
    this.clientFilter = filter;
  }

  public openAddClientModal(company) {
    let modal: any = AddClientWizardComponent;

    this.bsModalRef = this.modalService.show(modal, {
      ignoreBackdropClick: true,
    });

    this.bsModalRef.content.onClose.subscribe((res) => {
      if (res != null) {
        if (this.dashboardStore.clients.length == 0) {
          this.dashboardStore.getClients();
        }

        this.navigate(res.id);
      }
    });

    if (company != null) {
      this.bsModalRef.content.invited_to = company.id;
      this.bsModalRef.content.name = company.name;
      this.bsModalRef.content.ngOnChanges({});
    }
  }

  public openAddClientExistingUsersModal(company) {
    this.bsModalRef = this.modalService.show(AddExistingClientModalComponent, {
      class: "modal-lg",
    });
    if (company != null) {
      this.bsModalRef.content.invited_to = company.id;
      this.bsModalRef.content.name = company.name;
      this.bsModalRef.content.ngOnChanges({});
    }
  }

  trackClient(index, client) {
    return client["company_conversation"]
      ? client["company_conversation"].id
      : undefined;
  }

  goToCustomerPortal() {
    this.show_loading = true;
    this.stripeService
      .getCustomerPortalSession()
      .subscribe((res: any) => (window.location.href = res.url));
  }

  navigateToPracticeInfo() {
    this.router.navigate(["/practice/practice-info"]);
  }

  calculateIsPastPeriodEnd(epochPeriodEnd: any) {
    if (!epochPeriodEnd) return true;
    const subscriptionPeriodEnd = epochPeriodEnd * 1000;
    const today = Date.parse(new Date().toISOString());
    const isPastPeriodEnd = today > subscriptionPeriodEnd;
    console.warn("Is past subscription period?", isPastPeriodEnd);
    console.warn(new Date(subscriptionPeriodEnd));
    return isPastPeriodEnd;
  }

  calculateIsEligibleForGracePeriod(epochPeriodEnd: any) {
    if (!epochPeriodEnd) return true;
    const startOfGracePeriod = new Date(epochPeriodEnd * 1000);
    startOfGracePeriod.setDate(startOfGracePeriod.getDate() + 28);
    const isEligible = startOfGracePeriod < new Date();
    console.warn("Is eligible for Grace Period?", isEligible);
    console.warn("Grace period begins on", new Date(startOfGracePeriod));
    return isEligible;
  }

  addTagToFilter(tag) {
    this.selectedFilterTags.push(tag);
    this.tagList.addedTags = this.selectedFilterTags;

    this.tagList.tags = this.tagList.tags.filter((t) => t.uuid !== tag.uuid);
    this.applyFilter();
    this.tagList.dropdown.show();
  }

  removeTagFromFilter(tag) {
    this.tagList.tags.push(tag);
    this.selectedFilterTags = this.selectedFilterTags.filter(
      (t) => t.uuid !== tag.uuid,
    );

    this.tagList.addedTags = this.selectedFilterTags;
  }

  applyFilter() {
    console.log("all_clients", this.dashboardStore.all_clients);
    // filter dashboardStore.clients by tags
    this.dashboardStore.clients = this.dashboardStore.all_clients.filter(
      (client) => {
        return client.tags.filter((tag) => {
          return this.selectedFilterTags.find((t) => t.uuid == tag.uuid);
        });
      },
    );
  }

  clearFilter() {
    this.selectedFilterTags = [];
    this.tagList.tags = this.tagList.all_tags;
    this.tagList.dropdown.hide();
  }

  filterClientsByTagAndUnread(clients) {
    if (this.selectedFilterTags.length > 0) {
      return clients
        .filter((client) => {
          return this.selectedFilterTags.some((tag) => {
            if (client.tags != null) {
              return client.tags.some((t) => t.uuid == tag.uuid);
            }

            return false;
          });
        })
        .filter((c) => {
          c["company_conversation"].read == false ||
            c["company_conversation"].has_notifications === true;
        });
    } else {
      return clients;
    }
  }

  notificationsLoaded(notifications) {
    for (let x = 0; x < this.dashboardStore.clients.length; x++) {
      if (
        notifications.filter(
          (n) =>
            n.read == false &&
            n.notification.conversation ==
              this.dashboardStore.clients[x]["company_conversation"].id,
        ).length > 0
      ) {
        this.dashboardStore.clients[x][
          "company_conversation"
        ].has_notifications = true;
      }
    }
  }

  toggleBatchClientTasks(bool: boolean) {
    this.selectedConversationIds = [];
    this.batch_client_tasks = bool;
  }

  changeAndOrFilter(andOr) {
    this.andOrFilter = andOr;
  }

  selectConversation(conversationId: number) {
    if (this.sharedDataService.subscriptionType != SubscriptionType.FREE) {
      const idx = this.selectedConversationIds.indexOf(conversationId);
      idx < 0
        ? this.selectedConversationIds.push(conversationId)
        : this.selectedConversationIds.splice(idx, 1);

      this.navigate(conversationId);
    }
  }

  isConversationSelected(conversationId: number) {
    return this.selectedConversationIds.includes(conversationId);
  }

  selectAllConversations() {
    let clients = this.dashboardStore.clients.filter((client) => {
      return client.archived == false;
    });

    // applying the same logic as the ClientTagSearchPipe pipe
    if (this.selectedFilterTags.length > 0) {
      if (this.andOrFilter === "or") {
        clients = this.dashboardStore.clients.filter((client) => {
          return (
            this.selectedFilterTags.some((tag) => {
              return client.tags.some((t) => t.uuid === tag.uuid);
            }) && client.archived === false
          );
        });
      } else if (this.andOrFilter === "and") {
        clients = this.dashboardStore.clients.filter((client) => {
          return (
            this.selectedFilterTags.every((tag) => {
              return client.tags.some((t) => t.uuid === tag.uuid);
            }) && client.archived === false
          );
        });
      } else if (this.andOrFilter === "not") {
        clients = this.dashboardStore.clients.filter((client) => {
          return (
            !this.selectedFilterTags.some((tag) => {
              return client.tags.some((t) => t.uuid === tag.uuid);
            }) && client.archived === false
          );
        });
      }
    }

    const allConversationIds = clients.map((c) => c.id);
    if (this.selectedConversationIds.length < allConversationIds.length) {
      this.selectedConversationIds = allConversationIds;
    } else {
      this.selectedConversationIds = [];
    }
  }

  launchClientTaskModal() {
    this.bsModalRef = this.modalService.show(NewTrackedItemModalComponent, {
      class: "modal-lg modal-client-tasks",
      ignoreBackdropClick: true,
      initialState: {
        isBatch: true,
        conversations: this.getConversationsForBatch(),
      },
    });

    this.bsModalRef.onHide.subscribe((res) => {
      this.selectedConversationIds = [];
      this.batch_client_tasks = false;
    });
    return;
  }

  launchJobPickerModal() {
    this.bsModalRef = this.modalService.show(JobPickerModalComponent, {
      class: "modal-md",
      ignoreBackdropClick: true,
      initialState: {
        conversations: this.getConversationsForBatch(),
      },
    });
    this.bsModalRef.onHide.subscribe((res) => {
      this.selectedConversationIds = [];
      this.batch_client_tasks = false;
    });
  }

  launchMessageModal() {
    this.bsModalRef = this.modalService.show(BatchActionMessageComponent, {
      class: "modal-lg",
      initialState: {
        conversations: this.getConversationsForBatch(),
      },
    });
    this.bsModalRef.content.onClose.subscribe((res) => {
      if (res) {
        this.selectedConversationIds = [];
        this.batch_client_tasks = false;
      }
    });
  }

  getConversationsForBatch(): any[] {
    const mappedClientCompanies = this.dashboardStore.clients
      .map((c) => {
        return { conversationId: c.id, conversationName: c.name };
      })
      .filter((f) => this.selectedConversationIds.includes(f.conversationId));
    return mappedClientCompanies;
  }

  navigate(id) {
    // first time a client is added this.dashboardStore.currentCompany is undefined

    if (this.dashboardStore.currentCompany == null) {
      if (this.dashboardStore.clients.length > 0) {
        this.dashboardStore.currentCompany = this.dashboardStore.clients.find(
          (c) => c.id == id,
        );
      }
    }

    if (this.router.url.includes(this.dashboardStore.currentCompany.id)) {
      this.router.navigateByUrl(
        this.router.url.replace(this.dashboardStore.currentCompany.id, id),
      );
    } else {
      let lastTab =
        this.localStorage.get("last_tab") != null
          ? this.localStorage.get("last_tab")
          : "conversations";

      this.router.navigateByUrl("practice/workspaces/" + id + "/" + lastTab);
    }
  }

  closeJobDrawer() {
    this.showJobModal = false;
    this.job = null;

    this.cdr.detectChanges();
  }
}

@Pipe({
  name: "clientTagSearch",
  standalone: true,
})
export class ClientTagSearchPipe implements PipeTransform {
  transform(value, selectedTags, anyOrFilter) {
    if (selectedTags.length > 0) {
      if (anyOrFilter === "or") {
        return value.filter((client) =>
          selectedTags.some((tag) =>
            client.tags.some((t) => t.uuid === tag.uuid),
          ),
        );
      } else if (anyOrFilter === "and") {
        return value.filter((client) =>
          selectedTags.every((tag) =>
            client.tags.some((t) => t.uuid === tag.uuid),
          ),
        );
      } else if (anyOrFilter === "not") {
        return value.filter(
          (client) =>
            !selectedTags.some((tag) =>
              client.tags.some((t) => t.uuid === tag.uuid),
            ),
        );
      }
    }
    return value;
  }
}
